import { styled } from '@mui/material';
import Loading from '../icons/Loading';

export const SpinningLoading = styled(Loading)(() => ({
  animation: 'rotation 2s infinite linear',
  '@keyframes rotation': {
    from: {
      transform: 'rotate(0deg)',
    },
    to: {
      transform: 'rotate(359deg)',
    },
  },
}));
